import {FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import SmsManagementPage from '../modules/smsManagement/SmsManagementPage'
import WalletListPage from '../modules/walletManagement/walletList/WalletListPage'
import WalletListPage_Edit from '../modules/walletManagement/walletList/WalletListPage_Edit'
import SmsManagementPage_View from '../modules/smsManagement/SmsManagementPage_View'
import Withdrawal_List_Page from '../modules/WithdrawalManagement/Withdrawal_List'
import CreditReload_List from '../modules/Agent_Management/Credit_Reload/CreditReload_List'
import CommissionWithdrawal_List from '../modules/Agent_Management/Commission_Withdrawal/CommissionWithdrawal_List'
import AgentSummary_List from '../modules/Agent_Management/Agent_Summary/AgentSummary_List'
import AgentSummary_Details from '../modules/Agent_Management/Agent_Summary/components/AgentSummary_Details'
import CreditReload_Create from '../modules/Agent_Management/Credit_Reload/components/CreditReload_Create'
import CommissionWithdrawal_Comm_Create from '../modules/Agent_Management/Commission_Withdrawal/components/CommissionWithdrawal_Comm_Create'
import WithdrawalManagement_ManualWithdrawal from '../modules/WithdrawalManagement/WithdrawalManagement_ManualWithdrawal'
import WalletListPage_Add from '../modules/walletManagement/walletList/WalletListPage_Add'

const AdminSPRRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='/sms/list'
          element={
            <SuspensedView>
              <SmsManagementPage />
            </SuspensedView>
          }
        />
        <Route
          path='/sms/list/:smsId'
          element={
            <SuspensedView>
              <SmsManagementPage_View />
            </SuspensedView>
          }
        />
        <Route
          path='/wallet/list'
          element={
            <SuspensedView>
              <WalletListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/wallet/list/create'
          element={
            <SuspensedView>
              <WalletListPage_Add />
            </SuspensedView>
          }
        />
        <Route
          path='/wallet/list/edit/:walletAccountNo'
          element={
            <SuspensedView>
              <WalletListPage_Edit />
            </SuspensedView>
          }
        />
        <Route
          path='/withdrawal/list'
          element={
            <SuspensedView>
              <Withdrawal_List_Page />
            </SuspensedView>
          }
        />
        <Route
          path='/withdrawal/manual-withdrawal-creation'
          element={
            <SuspensedView>
              <WithdrawalManagement_ManualWithdrawal />
            </SuspensedView>
          }
        />
        <Route
          path='/agent/credit-reload'
          element={
            <SuspensedView>
              <CreditReload_List />
            </SuspensedView>
          }
        />
        <Route
          path='/agent/commission-withdrawal'
          element={
            <SuspensedView>
              <CommissionWithdrawal_List />
            </SuspensedView>
          }
        />
        <Route
          path='/agent/summary'
          element={
            <SuspensedView>
              <AgentSummary_List />
            </SuspensedView>
          }
        />
        <Route
          path='/agent/summary/:agentUsername'
          element={
            <SuspensedView>
              <AgentSummary_Details />
            </SuspensedView>
          }
        />
        {/* <Route
          path='/agent/previous-day-summary'
          element={
            <SuspensedView>
              <PreviousDayAgentSummary_List />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='/agent/previous-day-summary/:agentUsername'
          element={
            <SuspensedView>
              <PreviousDayAgentSummary_Details />
            </SuspensedView>
          }
        /> */}
        <Route
          path='/agent/credit-reload/create'
          element={
            <SuspensedView>
              <CreditReload_Create />
            </SuspensedView>
          }
        />
        <Route
          path='/agent/commission-withdrawal/create'
          element={
            <SuspensedView>
              <CommissionWithdrawal_Comm_Create />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {AdminSPRRoutes}
